
export const getClient = (): string =>
    (import.meta.env.VITE_APP_BRAND || "").toUpperCase();


export const CLIENTS_CONFIG: Record<string, string[]> = {
    g_17:    [ "CADENT" ],
    hc_code: ["CADENT"],
    queries: ["CADENT"],
};


export const isFieldVisible = (fieldName: string): boolean => {
    const allowedClients = CLIENTS_CONFIG[fieldName];
    if (!allowedClients) return true; 
    return allowedClients.includes(getClient());
};
